import { useSelector } from "react-redux";

import { Grid, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import PhoneIcon from "@mui/icons-material/Phone";

import constants from "../../../../utils/constants";
import BookingStep from "./BookingStep";
import SquareButton from "../../../UI/SquareButton";

export default function MeetingType(props) {
  const requestType = useSelector((state) => state.booking.requestType);
  const onTypeSelected = props.onTypeSelected;

  return (
    <BookingStep
      header="default"
      subheader={
        <Typography variant="h6" mt={1}>
          How do you prefer to meet with us?
        </Typography>
      }
    >
      <Grid container alignItems="center" justifyContent="center" spacing={2}>
        {requestType !== constants.REQUEST_TYPES.INQUIRY && (
          <Grid item>
            <SquareButton name="In-Person" value={1} icon={<PersonIcon />} onClick={onTypeSelected} />
          </Grid>
        )}
        <Grid item>
          <SquareButton name="Virtual" value={2} icon={<PersonalVideoIcon />} onClick={onTypeSelected} />
        </Grid>
        <Grid item>
          <SquareButton name="Phone" value={3} icon={<PhoneIcon />} onClick={onTypeSelected} />
        </Grid>
      </Grid>
    </BookingStep>
  );
}
